import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { Subject } from 'rxjs';
import { EnvService } from '../env.service';
import { Constants } from '../middleware/common/reusableclassesAndFunctions/constants';
import { ApiEndPointsNotification } from './commonUtility/apiUrls/api-end-points-notification';

@Injectable({
  providedIn: 'root'
})

export class SignalRHubService {
  private connection: signalR.HubConnection;
  connectionEstablished = new Subject<Boolean>();
  notification = new Subject<any>();

  private baseUrlTrans:any;

  constructor(public env: EnvService,private constant: Constants,
    private apiAddress: ApiEndPointsNotification) {
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
    this.baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;
  }

  connect() {
    if (!this.connection) {
      const apiURL = this.baseUrlTrans + 'notificationhub';
      this.connection = new signalR.HubConnectionBuilder().withUrl(apiURL+'?diag=yes').build();

      this.connection.start().then(() => {      
        this.connectionEstablished.next(true);
      }).catch(err => console.log('Error while establishing connection'));

      this.connection.on('GetNotification', (createdby,message,moduleid,targetUserId,organizationID,DatabaseId) => {
       this.notification.next({ createdby,message,moduleid,targetUserId,organizationID,DatabaseId });
      });
     }
  }

 
  disconnect() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
    }
  }

  
}
